import { PAYMENT_METHOD_WITH_QR } from '~redux/Order/constants';

export const isPayingWithQr = (paymentMethod) => {
  return PAYMENT_METHOD_WITH_QR.some((payment) => payment === paymentMethod);
};
